import { Row, Col, Card, Tag, InputNumber, Button } from "antd";

const ProductAdminCard = ({
  product,
  showProdStatus,
  onSortingChange,
  onImageClick,
  onAddToDealClick = () => {},
  handleManageTagClick = () => {},
  onInstaGramPostClick = () => {},
}) => {
  const statusColors = {
    Available: "green",
    "Out of Stock": "orange",
  };

  //   const handleCardClick = () => {
  //     ReactGA.event({
  //       category: "Product",
  //       action: "clicked on product card",
  //       label: product.ProductName,
  //       value: product.ProductID,
  //     });
  //     sessionStorage.setItem("ProductID", product.ProductID);
  //     navigate(
  //       `/shop/${categoryName}/${product.ProductName}/${product.ProductID}`
  //     );
  //   };

  return (
    <Card
      hoverable
      //onClick={handleCardClick}
      style={{
        padding: 0,
        width: "100%",
        border:
          showProdStatus === true
            ? product.Status === "Available"
              ? "1px solid #52c41a"
              : undefined
            : "1px solid rgb(39, 178, 196)",
      }}
    >
      <Row align="middle" gutter={[16, 16]}>
        {/* Image on the left */}
        <Col xs={6} sm={4} md={4}>
          <img
            alt={product.ProductName}
            src={product.ImageUrl}
            style={{
              width: "100px",
              objectFit: "cover",
              borderRadius: 8,
            }}
            onClick={(e) => {
              e.stopPropagation();
              onImageClick(product.ProductID);
            }}
          />
        </Col>

        {/* Product name and status */}
        <Col xs={6} sm={10} md={10}>
          <h4 style={{ margin: 0 }}>{product.ProductName}</h4>
          <p style={{ margin: "8px 0", color: "#888" }}>
            {"Design No. : " + product.DesignNo}
          </p>
          <p style={{ fontWeight: 500, margin: "8px 0" }}>
            {"Rate : ₹ " + product.SalesRate.toFixed(2)}
          </p>
          {/* Show In Stock / Out of Stock status */}
          <p style={{ margin: "8px 0", fontWeight: 500 }}>
            Status:{" "}
            <span
              style={{
                color: product.Status === "Available" ? "#52c41a" : "#ff4d4f",
              }}
            >
              {product.Status === "Available" ? "In Stock" : "Out of Stock"}
            </span>
          </p>
        </Col>

        {/* Box Size and Colors */}
        <Col xs={3} sm={5} md={5}>
          {showProdStatus && (
            <Tag color={statusColors[product.Status]}>{product.Status}</Tag>
          )}
          <Tag color={product.IsInDeal === true ? "blue" : "purple-inverse"}>
            {product.IsInDeal === true ? "In Deal" : "Not in Deal"}
          </Tag>
          <p style={{ margin: "8px 0", color: "#888" }}>
            {"Box Size : " + product.QtyInBox + " " + product.Unit + "(s)"}
          </p>
          <p style={{ margin: "8px 0", color: "#888" }}>
            {"Colors : " + product.NoOfColor}
          </p>
        </Col>

        <Col xs={3} sm={3} md={3}>
          <InputNumber
            min={0}
            value={product.SortingVal}
            onChange={(value) => onSortingChange(product.ProductID, value)}
            style={{ width: "100%" }}
          />
        </Col>
      </Row>
      {/* Buttons at the bottom in a single line */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 8,
          marginTop: 16,
          flexWrap: "wrap",
        }}
      >
        <Button size="small" onClick={onAddToDealClick}>
          Add to Deal
        </Button>
        <Button
          size="small"
          style={{ marginLeft: 0 }}
          onClick={() => handleManageTagClick(product)}
        >
          Manage Tag
        </Button>
        {/* Create Instagram Post Button */}
        <Button
          style={{ marginTop: 8, marginRight: 8 }}
          onClick={onInstaGramPostClick}
        >
          Create Instagram Post
        </Button>
      </div>
      {/* Display Keywords if present */}
      {Array.isArray(product.Keywords) && product.Keywords.length > 0 && (
        <div style={{ marginTop: 8, marginLeft: 8 }}>
          <span style={{ fontWeight: 500, color: "#888" }}>Keywords: </span>
          {product.Keywords.map((kw, idx) => (
            <span
              key={idx}
              style={{
                display: "inline-block",
                background: "#f0f5ff",
                color: "#1677ff",
                borderRadius: 8,
                padding: "2px 10px",
                fontSize: 13,
                marginRight: 6,
                marginBottom: 4,
              }}
            >
              {kw}
            </span>
          ))}
        </div>
      )}
    </Card>
  );
};

export default ProductAdminCard;
